<template>
	<UIWaveSeparator background-color="brightGreen" class="mt-24 mb-14" size="sm">
		<h1
			class="svg-before mx-auto my-0 rotate-1 px-2 pt-6 text-center text-4xl font-black wrap-break-word sm:text-5xl md:text-6xl lg:text-7xl"
			:class="widthClasses"
		>
			<slot />
		</h1>
	</UIWaveSeparator>
</template>

<script lang="ts" setup>
const props = withDefaults(
	defineProps<{
		narrow?: boolean
	}>(),
	{
		narrow: false,
	}
)

const widthClasses = computed(() => {
	return props.narrow ? 'w-min' : 'w-fit'
})
</script>

<style>
.svg-before {
	position: relative;
}

.svg-before::after {
	content: '';
	position: absolute;
	top: 1rem;
	right: -0.5rem;
	width: 2.5rem;
	height: 2.5rem;
	background-image: url('/img/hut.svg');
	background-repeat: no-repeat;
	background-size: contain;
	transform: rotate(40deg);
}

/* Responsive sizing */
@media (min-width: 768px) {
	.svg-before::after {
		top: 0.75rem;
		right: -0.5rem;
		width: 3rem;
		height: 3rem;
	}
}
@media (min-width: 1024px) {
	.svg-before::after {
		top: 0.5rem;
		right: -1rem;
		width: 4rem;
		height: 4rem;
	}
}
</style>
